import styled from 'styled-components';

export const FlexboxBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) => props.fullHeight && 'height: 100%;'}
`;
